import { render, staticRenderFns } from "./UpdateHero.vue?vue&type=template&id=162c6c9c&"
import script from "./UpdateHero.vue?vue&type=script&lang=js&"
export * from "./UpdateHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports